"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EditorState_1 = require("../models/EditorState");

var actions = __importStar(require("./actions"));

function defaultState(text) {
  return EditorState_1.EditorState.createFromText(text);
}

exports.defaultState = defaultState;

function changeBuffer(state, action) {
  return __assign({}, state, {
    buffer: action.payload.buffer
  });
}

function closeHints(state) {
  return __assign({}, state, {
    hints: [],
    showHints: false
  });
}

function showHints(state, action) {
  return __assign({}, state, {
    hints: action.payload.completions,
    showHints: true
  });
}

function reducer(state, action) {
  switch (action.type) {
    case actions.BUFFER_CHANGE:
      return changeBuffer(state, action);

    case actions.HINTS_CLOSE:
      return closeHints(state);

    case actions.HINTS_SHOW:
      return showHints(state, action);

    default:
      return state;
  }
}

exports.default = reducer;